<template>
  <div>
    <b-modal id="select-action" centered hide-footer>
      <template #modal-header="{ close }">
        <h5>Giám sát thao tác</h5>
        <b-button size="sm" variant="light" @click="close(), (codeCheck = '')"> x </b-button>
      </template>
      <div class="button">
        <b-button
          v-if="dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_APPROVE_REJECT')"
          @click="onShowSelectDevice"
          class="b-button"
          variant="outline-secondary"
          >Duyệt KPI</b-button
        >
      </div>
      <div class="button">
        <b-button
          v-if="dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_APPROVE_REJECT')"
          @click="showModalUploadKpi('APPROVE')"
          class="b-button"
          variant="outline-secondary"
          >Upload file KPI được duyệt</b-button
        >
      </div>
      <div class="button">
        <b-button
          v-if="dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_EXPLANATION')"
          @click="showModalUploadKpi('ADDITIONAL')"
          class="b-button"
          variant="outline-secondary"
          >Upload file KPI cần SA giải trình</b-button
        >
      </div>
      <div class="button">
        <b-button
          v-if="dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_APPROVE_REJECT')"
          @click="showModalUploadKpi('REJECT')"
          class="b-button"
          variant="outline-secondary"
          >Upload file KPI bị từ chối</b-button
        >
      </div>
    </b-modal>
    <ModalUploadFileKpi
      v-if="isShowModalUploadKpi"
      :status="status"
      @reloadData="reloadData"
    ></ModalUploadFileKpi>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModalUploadFileKpi from './ModalUploadFileKpi.vue'
  export default {
    data() {
      return {
        isShowModalUploadKpi: false,
        status: '',
      }
    },
    components: {
      ModalUploadFileKpi,
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      showModalUploadKpi(status) {
        this.isShowModalUploadKpi = true
        this.status = status
        this.$nextTick(() => {
          this.$bvModal.show('upload-file-kpi')
          this.$bvModal.hide('select-action')
        })
      },
      onShowSelectDevice() {
        this.$emit('onShowSelectDevice', 'WAIT_MONITOR_APPROVE')
      },
      reloadData() {
        this.$emit('reloadData')
      },
    },
  }
</script>

<style scoped>
  .button {
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }
  .b-button {
    min-width: 225px;
  }
</style>
